import initDelivery from "./delivery/delivery";
import "./hero-section.scss";

const $getSection = () => document.querySelector(".js-jiffytransfers-landing-v2-hero-section");
const $getVideo = () => document.querySelector(".js-jiffytransfers-landing-v2-hero-video");

const SECTION_BACKGROUND_CLASS = "jiffytransfers-landing-v2-hero-section--background";

const initVideo = () => {
  const $section = $getSection();
  const $video = $getVideo();

  if (!$section || !$video) {
    return;
  }

  $video.load();

  if ($video.readyState >= 3) {
    $section.classList.remove(SECTION_BACKGROUND_CLASS);
  }

  $video.addEventListener("canplay", () => {
    $section.classList.remove(SECTION_BACKGROUND_CLASS);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initDelivery();
  initVideo();
});
